import { InputFilterType } from '@share/common-types';
import {  IEmployeeColumnMenu } from '../pages';

const showAvatar: any = (text: any, record: any, rest: any) => {
  return (
    <div>
      <img 
        src={record.avatar} 
        alt={record.avatar || 'img'} 
        style={{ width: '50px', height: '50px', borderRadius: '50%' }} 
      />
    </div>
  );
};

export const MyEmployeeColumnMenu: IEmployeeColumnMenu[] = [
  {
    description: 'Employee Photo',
    key: 'avatar',
    width: 140,
    display: true,
    order: 1,
    type: InputFilterType.Text,
    displayConditions: false,
    sortable: false,
    component: showAvatar,
  },
  // {
  //   description: 'Employee #',
  //   key: 'employee_number',
  //   width: 125,
  //   display: true,
  //   order: 2,
  //   type: InputFilterType.IntegerNumber,
  //   displayConditions: false,
  //   sortable: false,
  // },
  {
    description: 'First Name',
    key: 'first_name',
    width: 140,
    display: true,
    order: 3,
    type: InputFilterType.Text,
    displayConditions: false,
    sortable: false,
  },
  {
    description: 'Last Name',
    key: 'last_name',
    width: 140,
    display: true,
    order: 3,
    type: InputFilterType.Text,
    displayConditions: false,
    sortable: false,
  },
  {
    description: 'Gender',
    key: 'gender',
    width: 85,
    display: true,
    order: 4,
    type: InputFilterType.Text,
    displayConditions: false,
    sortable: false,
  },
  {
    description: 'Work Email',
    key: 'work_email',
    width: 230,
    display: true,
    order: 4,
    type: InputFilterType.Text,
    displayConditions: false,
    sortable: false,
  },
  // {
  //   description: 'Employment Status',
  //   key: 'employment_status',
  //   width: 140,
  //   display: true,
  //   order: 5,
  //   type: InputFilterType.Text,
  //   displayConditions: false,
  //   sortable: false,
  // },
  {
    description: 'Date Of Birth',
    key: 'date_of_birth',
    width: 140,
    incomingDateFormat: 'MM/DD/YYYY',
    display: true,
    order: 6,
    type: InputFilterType.Date,
    sortable: false,
  },
  {
    description: 'Phone Number',
    key: 'mobile_phone_number',
    width: 140,
    display: true,
    order: 4,
    type: InputFilterType.Text,
    displayConditions: false,
    sortable: false,
  },
];


